var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "share-icon_svg__a",
    d: "M0 .862h9.36v9.51H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "share-icon_svg__c",
    d: "M.141.5H9.5v9.51H.141z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "share-icon_svg__e",
    d: "M.141.49H9.5V10H.141z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.68 11.699c-1.853 0-3.36 1.533-3.36 3.418 0 1.885 1.507 3.418 3.36 3.418 1.854 0 3.36-1.533 3.36-3.418 0-1.885-1.506-3.418-3.36-3.418m0 7.924c-2.441 0-4.43-2.021-4.43-4.506 0-2.484 1.989-4.505 4.43-4.505 2.443 0 4.43 2.02 4.43 4.505s-1.987 4.506-4.43 4.506",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "share-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#share-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.68 2.449c-1.715 0-3.11 1.42-3.11 3.168 0 1.747 1.395 3.168 3.11 3.168 1.716 0 3.11-1.421 3.11-3.168S6.397 2.449 4.68 2.449m0 6.836c-1.99 0-3.61-1.645-3.61-3.668 0-2.022 1.62-3.668 3.61-3.668 1.992 0 3.61 1.646 3.61 3.668 0 2.023-1.618 3.668-3.61 3.668m0-7.923C2.376 1.362.5 3.27.5 5.617c0 2.347 1.875 4.256 4.18 4.256 2.305 0 4.18-1.91 4.18-4.256S6.985 1.362 4.68 1.362m0 9.01C2.1 10.373 0 8.24 0 5.618 0 2.995 2.1.862 4.68.862c2.58 0 4.68 2.133 4.68 4.755 0 2.623-2.1 4.756-4.68 4.756",
    fill: "currentColor",
    mask: "url(#share-icon_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.821 2.337c-1.854 0-3.36 1.534-3.36 3.418 0 1.885 1.506 3.419 3.36 3.419 1.853 0 3.36-1.534 3.36-3.42 0-1.883-1.507-3.417-3.36-3.417m0 7.924c-2.442 0-4.43-2.021-4.43-4.506 0-2.484 1.988-4.505 4.43-4.505 2.442 0 4.43 2.02 4.43 4.505s-1.988 4.506-4.43 4.506",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 .5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "share-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#share-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.821 2.087c-1.716 0-3.11 1.42-3.11 3.168 0 1.748 1.394 3.169 3.11 3.169 1.715 0 3.11-1.421 3.11-3.17 0-1.746-1.395-3.167-3.11-3.167m0 6.837c-1.99 0-3.61-1.646-3.61-3.67 0-2.021 1.62-3.667 3.61-3.667 1.991 0 3.61 1.646 3.61 3.668 0 2.023-1.619 3.669-3.61 3.669m0-7.924C2.516 1 .641 2.909.641 5.255c0 2.347 1.875 4.256 4.18 4.256 2.304 0 4.18-1.91 4.18-4.256S7.124 1 4.82 1m0 9.01c-2.58 0-4.68-2.132-4.68-4.755C.141 2.633 2.241.5 4.821.5c2.58 0 4.68 2.133 4.68 4.755 0 2.623-2.1 4.756-4.68 4.756",
    fill: "currentColor",
    mask: "url(#share-icon_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.821 21.327c-1.854 0-3.36 1.533-3.36 3.418 0 1.885 1.506 3.418 3.36 3.418 1.853 0 3.36-1.533 3.36-3.418 0-1.885-1.507-3.418-3.36-3.418m0 7.923c-2.442 0-4.43-2.021-4.43-4.505s1.988-4.505 4.43-4.505c2.442 0 4.43 2.02 4.43 4.505 0 2.484-1.988 4.505-4.43 4.505",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 19.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "share-icon_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#share-icon_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.821 2.077c-1.716 0-3.11 1.42-3.11 3.168 0 1.747 1.394 3.168 3.11 3.168 1.715 0 3.11-1.421 3.11-3.168s-1.395-3.168-3.11-3.168m0 6.836c-1.99 0-3.61-1.645-3.61-3.668 0-2.022 1.62-3.668 3.61-3.668 1.991 0 3.61 1.646 3.61 3.668 0 2.023-1.619 3.668-3.61 3.668m0-7.923C2.516.99.641 2.899.641 5.245S2.516 9.5 4.821 9.5c2.304 0 4.18-1.91 4.18-4.255C9 2.899 7.124.99 4.82.99m0 9.01c-2.58 0-4.68-2.133-4.68-4.755S2.241.49 4.821.49c2.58 0 4.68 2.133 4.68 4.755S7.4 10 4.82 10",
    fill: "currentColor",
    mask: "url(#share-icon_svg__f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.076 24.356l-8.85-6.616.362-.5 8.85 6.616z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.572 17.688l8.45 6.316.07-.095-8.45-6.317-.07.096zm8.558 7.021l-9.25-6.916.654-.906 9.25 6.916-.654.906zM7.532 12.981l-.295-.543 8.808-4.949.296.543z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.574 12.535l.057.104 8.372-4.704-.057-.104-8.372 4.704zm-.14.79L6.9 12.34l9.243-5.194.535.983-9.245 5.194z",
    fill: "currentColor"
  }))));
}

export default SvgShareIcon;